import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IBookmarkRepository } from '../../repositories/interfaces/iBookmarkRepository';

export interface IGetBookmarkUseCase {
    execute(apiKey: string, profileGuid: string, token: string, identityToken: string): Promise<boolean>;
}

export class GetBookmarkUseCase implements IGetBookmarkUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get getBookmark(): IBookmarkRepository {
        return container.resolve<IBookmarkRepository>(DI.REPOSITORIES.IBookmarkRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(apiKey: string, profileGuid: string, token: string, identityToken: string): Promise<any> {
        return await this.getBookmark.getBookmark(apiKey, profileGuid, token, identityToken);
    }
}
